export default __webpack_public_path__ + "static/design01-ab69b818749122f795924d1f0bdb2e5d.jpg";